/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import Layout from "../../layout";
import ClientField from "./features/clientfield";

const AddClients = () => {
  return (
    <>
      <Layout>
        <section className="main_area">
          <ClientField />
        </section>
      </Layout>
    </>
  );
};
export default AddClients;
